module.exports = __webpack_public_path__ + "static/03-d36b5890faba7121e8aa99ebd1c34d72.jpg";